import React from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';

import {
    isLoggedIn,
    hasSignedLicences,
    isDeactivated,
} from '../../../services/auth';

const AuthorisedRoute = ({ component: Component, ...rest }) => {
    const { pathname } = useLocation();
    const licenceAgreementPath = '/licence-agreement';
    const isViewingLicenceAgreement = pathname === licenceAgreementPath;

    return (
        <Route
            {...rest}
            render={(props) => {
                if (
                    isLoggedIn() &&
                    !isDeactivated() &&
                    (hasSignedLicences() || isViewingLicenceAgreement)
                ) {
                    return <Component {...props} />;
                }

                if (isLoggedIn() && !hasSignedLicences() && !isDeactivated()) {
                    return (
                        <Redirect
                            to={{
                                pathname: licenceAgreementPath,
                                state: { from: props.location },
                            }}
                        />
                    );
                }
                return (
                    <Redirect
                        to={{
                            pathname: '/sign-in',
                            state: { from: pathname },
                        }}
                    />
                );
            }}
        />
    );
};

export default AuthorisedRoute;
